/**
 * Copyright 2021 mmmint.ai info@mmmint.ai - All Rights Reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential to MMM Intelligence UG (haftungsbeschränkt).
 */

import { MrfiktivHttpClientProvider } from "../../mrfiktiv-http-client.provider";
import {
  MrfiktivFleetVehicleInsuranceContractViewModelGen,
  MrfiktivFleetVehicleLeasingContractViewModelGen
} from "../../v1/data-contracts";
import { FleetVehicleContracts } from "../../v1/FleetVehicleContracts";

export type MrfiktivVehicleContractViewModelGen =
  | MrfiktivFleetVehicleLeasingContractViewModelGen
  | MrfiktivFleetVehicleInsuranceContractViewModelGen;

export class FleetVehicleContractService {
  proxy: FleetVehicleContracts;

  constructor(clientProvider: MrfiktivHttpClientProvider) {
    this.proxy = new FleetVehicleContracts(clientProvider.client());
  }

  async getByVehicle(
    partnerId: string,
    fleetId: string,
    vehicleId: string
  ): Promise<MrfiktivVehicleContractViewModelGen[]> {
    const response = await this.proxy.fleetVehicleContractControllerGetByVehicle(partnerId, fleetId, vehicleId);
    return response.data ?? [];
  }
}

export default new FleetVehicleContractService(new MrfiktivHttpClientProvider());
